import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  @Input() pageTitle: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/shane/workspace/website/website-client/src/app/banner/banner.component.ts